import { createRouter, createWebHistory } from "vue-router";
import Identifiers from "./views/Compliance/Identifiers/Identifiers.vue";
import Variants from "./views/Compliance/Variants/Variants.vue";
import Lifecycle from "views/Compliance/Lifecycle/Lifecycle.vue";
import FunctionalElements from "views/Compliance/FunctionalElements/FunctionalElements.vue";
import Operators from "views/Operators/Operators.vue";
import Compliance from "views/Compliance/Compliance.vue";
import Sterilization from "views/Compliance/Sterilization/Sterilization.vue";
import Disinfection from "views/Compliance/Disinfection/Disinfection.vue";
import Cleaning from "views/Compliance/Cleaning/Cleaning.vue";
import SterilizationSpecification from "views/Compliance/Sterilization/SterilizationSpecification.vue";
import User from "views/Compliance/User/User.vue";
import UserSpecification from "views/Compliance/User/UserSpecification.vue";
import Markets from "views/Compliance/Markets/Markets.vue";
import FunctionalElementsGraph from "views/Compliance/FunctionalElements/Graph/index.vue";
import FuncionalElementsFigureAnnotator from "views/Compliance/FunctionalElements/FigureAnnotator/index.vue";
import ContactProfiles from "views/Compliance/ContactProfiles/ContactProfiles.vue";

export enum RouteName {
  HOME = "Home",
  IDENTIFIERS = "Identifiers",
  VARIANTS = "Variants",
  MARKETS = "Markets",
  LIFECYCLE = "Lifecycle",
  STERILIZATION = "Sterilization",
  STERILIZATION_SPECIFICATION = "SterilizationSpecification",
  DISINFECTION = "Disinfection",
  CLEANING = "Cleaning",
  FUNCTIONAL_ELEMENTS = "FunctionalElements",
  FUNCTIONAL_ELEMENTS_GRAPH = "FunctionalElementsGraph",
  FUNCTIONAL_ELEMENTS_FIGURE = "FunctionalElementsFigure",
  DEVICE_COMPONENTS = "DeviceComponents",
  DEVICE_FIGURES = "DeviceFigures",
  OPERATORS = "Operators",
  COMPLIANCE = "Compliance",
  USER = "User",
  USER_SPECIFICATION = "UserSpecification",
  CONTACT_PROFILES = "ContactProfiles",
}

export function createAppRouter() {
  return createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: "/",
        redirect: "/compliance/identifiers",
      },
      {
        path: "/compliance",
        redirect: "/compliance/identifiers",
        component: Compliance,
        name: RouteName.COMPLIANCE,
        children: [
          {
            path: "identifiers",
            component: Identifiers,
            name: RouteName.IDENTIFIERS,
          },
          {
            path: "variants",
            component: Variants,
            name: RouteName.VARIANTS,
          },
          {
            path: "markets",
            component: Markets,
            name: RouteName.MARKETS,
          },
          {
            path: "lifecycle",
            component: Lifecycle,
            name: RouteName.LIFECYCLE,
          },
          {
            path: "microbiology/sterilization",
            component: Sterilization,
            name: RouteName.STERILIZATION,
          },
          {
            path: "microbiology/sterilization/specification/:id",
            component: SterilizationSpecification,
            name: RouteName.STERILIZATION_SPECIFICATION,
          },
          {
            path: "microbiology/disinfection",
            component: Disinfection,
            name: RouteName.DISINFECTION,
          },
          {
            path: "microbiology/cleaning",
            component: Cleaning,
            name: RouteName.CLEANING,
          },
          {
            path: "functional-elements",
            redirect: "/compliance/functional-elements/graph",
            component: FunctionalElements,
            name: RouteName.FUNCTIONAL_ELEMENTS,
            children: [
              {
                path: "graph",
                component: FunctionalElementsGraph,
                name: RouteName.FUNCTIONAL_ELEMENTS_GRAPH,
              },
              {
                path: ":id/figure",
                component: FuncionalElementsFigureAnnotator,
                name: RouteName.FUNCTIONAL_ELEMENTS_FIGURE,
              },
            ],
          },
          {
            path: "contact-profiles",
            component: ContactProfiles,
            name: RouteName.CONTACT_PROFILES,
          },

          {
            path: "user",
            component: User,
            name: RouteName.USER,
          },
          {
            path: "user/specification/:id",
            component: UserSpecification,
            name: RouteName.USER_SPECIFICATION,
          },
        ],
      },

      {
        path: "/operators",
        component: Operators,
        name: RouteName.OPERATORS,
      },
    ],
  });
}
